import { Bill2, Payment1, PaymentStatusEnum } from '~types'

export const amountDue = (bill: Bill2): number => {
  // this function should stay consistent with the property on the Bill model
  return subtotal(bill) - amountPaid(bill)
}

export const amountDueEither = (bill: Bill2): number => {
  return subtotalEither(bill) - amountPaid(bill)
}

export const amountDueIncludePending = (bill: Bill2): number => {
  return subtotal(bill) - amountPaidIncludePending(bill)
}

export const amountPaid = (bill: Bill2): number => {
  // this function should stay consistent with the property on the Bill model
  return bill.payments.reduce((acc, payment) => {
    if (payment.complete) {
      return acc + payment.amount
    } else {
      return acc
    }
  }, 0)
}

export const amountPaidIncludePending = (bill: Bill2): number => {
  return amountPaid(bill) + amountPaidPending(bill)
}

export const amountPaidPending = (bill: Bill2): number => {
  return bill.payments
    .filter((payment) => payment.status === PaymentStatusEnum.enum.processing)
    .reduce((sum, payment) => sum + payment.amount, 0)
}

export const billPaid = (bill: Bill2): boolean => {
  if (bill.editable) {
    return amountPaid(bill) > 0
  } else {
    return amountDue(bill) <= 0
  }
}

export const billPaidEither = (bill: Bill2): boolean => {
  return amountPaid(bill) > 0 && (amountDueEither(bill) <= 0 || bill.editable)
}

export const billPaidPending = (bill: Bill2): boolean => {
  if (bill.editable) {
    return amountPaidPending(bill) > 0
  } else {
    return amountDueIncludePending(bill) <= 0
  }
}

export const subtotal = (bill: Bill2): number => {
  // this function should stay consistent with the property on the Bill model
  if (!bill.charges) {
    return 0
  } else {
    return bill.charges.reduce((acc, charge) => acc + charge.amount, 0)
  }
}

export const subtotalEither = (bill: Bill2): number => {
  const subtotalAmount = subtotal(bill)
  if (bill.editable && subtotalAmount == 0) {
    return amountPaid(bill)
  } else {
    return subtotalAmount
  }
}

export const totalBillOrPayment = (bill: Bill2, payment: Payment1 | null): number => {
  if (payment && payment?.status === PaymentStatusEnum.enum.succeeded) {
    return payment.amount
  } else {
    return amountPaid(bill)
  }
}
